import React, { useEffect } from 'react';
import './Hero3.css';

export default function Hero3() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.hero3 .animate-side');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="hero3">

      <h1 className="animate-side slide-left">Our Goal</h1>

      <div className="hero3-1">
        <div className="hero3-2">

          <p className="animate-side slide-right">
            At <strong>Dataharbor</strong>, our goal is to simplify, modernize, and scale everyday business 
            operations through smart digital solutions. Whether empowering retail shops with 
            cloud POS systems, equipping restaurants with interactive digital menus, or 
            building custom web and mobile apps, we aim to bridge the gap between complex 
            software and smooth, user-friendly experiences.
          </p>

          <p className="animate-side slide-left">
            Launch quickly and sell everywhere your customers spend their time.
          </p>
        </div>
      </div>
    </section>
  );
}